import type { TFeedbackQuestionOption } from '../types';
import DisAgreeIcon from '../assets/icons/disagress_icon.svg';
import ExtremelyAgreeIcon from '../assets/icons/extremely_agree_icon.svg';
import SeemsOkeyIcon from '../assets/icons/seems_okey_icon.svg';
import SlightAgreeIcon from '../assets/icons/slightly_agree_icon.svg';
import SlightDisAgreeIcon from '../assets/icons/slightly_disagress.svg';

export const FEEDBACK_DATA: TFeedbackQuestionOption[] = [
  {
    key: 'STRONGLY_DISAGREE',
    icon: DisAgreeIcon,
    label: 'Strongly disagree',
  },
  {
    key: 'SLIGHTLY_DISAGREE',
    icon: SlightDisAgreeIcon,
    label: 'Slightly disagree',
  },
  {
    key: 'SEEMS_OKAY',
    icon: SeemsOkeyIcon,
    label: 'It seems okay',
  },
  {
    key: 'SLIGHTLY_AGREE',
    icon: SlightAgreeIcon,
    label: 'Slightly agree',
  },
  {
    key: 'EXTREMELY_AGREE',
    icon: ExtremelyAgreeIcon,
    label: 'Extremely agree',
  },
];

export const RECOMMEND_DATA: TFeedbackQuestionOption[] = [
  {
    key: 'SEO',
    label: 'SEO',
  },
  {
    key: 'OPTIMIZING',
    label: 'Optimizing',
  },
  {
    key: 'STRUCTURE_LAYOUT',
    label: 'Structure & Layout',
  },
  {
    key: 'DESIGN_CONTENT',
    label: 'Design & Content',
  },
  {
    key: 'OTHER',
    label: 'Other',
  },
];

export const FEEDBACK_STEP = {
  FIRST: {
    id: 1,
    header: 'Quick survey question!',
    content: 'GemMeter is essential during the process of building my landing page',
    buttonText: 'Next',
  },
  SECOND: {
    id: 2,
    header: 'Let us hear your thoughts!',
    content:
      'We’re sorry if your experience isn’t good enough. Please tell us how we can improve our product (Optional)',
    content2: 'Which issues you’d like us to focus more in the future?',
    buttonText: 'Submit',
  },
};

export const MODULE_NAME = 'feedback';
